// extracted by mini-css-extract-plugin
module.exports = {"root":"StyleWithProducts_root__4Yk7_","styleWith":"StyleWithProducts_styleWith__IrWM0"};